/**
 * Created by Mark on 01/12/2016.
 */


import React from "react";
import TableHeader from "./table.header.component.js";
import TableBody   from "./table.body.component.js";
import TableControlsComponent from "./table.controls.component.js";
import TableFooter from './table.footer.component.js';
import fuzzysearch from 'fuzzysearch';
import { Link } from 'react-router'
export default class Table extends React.Component {

    constructor(props){
        super();

        this.pops = props;
        var rowLimit = props.rowLimit || 30;
        var schema = props.schema;
        var strict = props.strictSearch || false;
        var rows = this.loadRows(schema);
        this.state = {
            rowLimit : rowLimit ,
            rowIndex : 0 ,
            enableSearch:true,
            enableActions:props.enableActions,
            schema: schema || null,
            multiSort: false,
            sortDictionary : {},
            rows :rows,
            strict: strict,
            totalRows:rows.length,
            pageNumberTotal: Math.round(rows.length/rowLimit),
            pageIndex : 0 ,
            columns:this.loadColumns(schema.properties),
            editaction: props.editaction || false,
            editButtonText: props.editButtonText || "...",
            additionalButtons: props.additionalButtons || [],
            deleteaction:props.deleteaction || false,
        };
        this.reloadTable(props.schema);
    }

    reloadTable(schema) {
        var rowLimit = this.state.rowLimit || 30;
        var rows = this.loadRows(schema);
        this.state.schema = schema;
        this.setState({
            rows:rows,
            pageIndex : 0 ,
            pageNumberTotal: Math.round(rows.length/this.state.rowLimit)
        })
    }

    componentWillReceiveProps(props){


        var rowLimit = props.rowLimit || 10;
        var schema = props.schema;
        var rows = this.loadRows(schema);
        var strict = props.strictSearch || false;

        this.state = {
            rowLimit : rowLimit ,
            rowIndex : 0 ,
            enableSearch:true,
            enableActions:props.enableActions,
            schema: schema || null,
            multiSort: false,
            sortDictionary : {},
            rows :rows,
            strict: strict,
            totalRows:rows.length,
            pageNumberTotal: Math.round(rows.length/rowLimit),
            pageIndex : 0 ,
            columns:this.loadColumns(schema.properties),
            editaction: props.editaction || false,
            editButtonText: props.editButtonText || "...",
            additionalButtons: props.additionalButtons || [],
            deleteaction:props.deleteaction
        };
        this.reloadTable(props.schema);
    }

    updatePageIndex(index){
        this.setState({pageIndex : index})
    };

    updateDisplayableColumns(columnUID , showBoolean){

        var schema = this.state.schema;
            schema.properties[columnUID].display = showBoolean;

        this.setState({
            schema:schema,
            columns:this.loadColumns(schema.properties),
            rows:this.loadRows(schema),
        });
    }

    getRowSection(){
        var rowLimit  = parseInt(this.state.rowLimit);
        return this.state.rows.slice(this.state.pageIndex*rowLimit, (this.state.pageIndex*rowLimit) + rowLimit);
    }

    loadColumns(properties) {
        var sorted = false;
        var columns = [];

        for(var propertyKey in properties){

            var column = properties[propertyKey];

            if(column.display !== true) continue;
            if(column.order != null) this.state.sortDictionary[propertyKey] = column.order;
            //if(!this.state.multiSort && column.order !== null) sorted = true;


            columns.push(column);
        }

       return columns;
    }

    formatValues(){

    }

    formatValue(value , type){

        switch(String(type).toLowerCase())
        {
            case 'string'  : return String(value);
            case 'boolean' : return value ? true : false;
            case 'integer' : return Number(value);
            case 'link'    : return <Link to={value.link}>
                                        <i className="zmdi zmdi-link p-r-5"></i>{value.value}
                                    </Link>;
            case 'linkgroup' :

                    if(!value.length) return;

                    var dom = [];

                    for(var idx = 0 ; idx < value.length; idx++){
                        dom.push(<li><Link to={value[idx].link}><i className="zmdi zmdi-link p-r-5"></i>{value[idx].value}</Link></li>)
                    }

                    return dom;

                break;
            case 'group' :

                    if(!value.length) return;

                    var dom = [];

                    for(var idx = 0 ; idx < value.length; idx++){
                        dom.push(<li>{value[idx].value}</li>)
                    }

                    return dom;

                break;
            case "identification": return value; break;
            default : return value
        }

    }

    loadRows(schema)
    {
        var columns = this.loadColumns(schema.properties);
        var rows = [];

        for(var idx = 0; idx < schema.data.length; idx++)
        {
            var row = schema.data[idx];
            rows[idx] = [];

            for(var jdx = 0; jdx < columns.length; jdx++)
            {


                rows[idx].push({
                    id: row['uid'],
                    rawValue:row[columns[jdx].id],
                    value:this.formatValue(row[columns[jdx].id] , columns[jdx].type),
                    className:columns[jdx].className
                });
            }
        }

        return rows;
    }

    handelUserSearch(searchTerm){

        var rows = this.loadRows(this.state.schema);

        var searchedRows = [];

        for (var idx = 0; idx < rows.length; idx++) {
            for (var jdx = 0; jdx < rows[idx].length; jdx++) {
                if (this.state.strict) {
                    // if you want a different kind of search (not fuzzy) then pop it in here and pass strict = true in props, but for now, fuzzy it is...
                    if (fuzzysearch(String(searchTerm).toLowerCase(), JSON.stringify(rows[idx][0].rawValue.value).toLowerCase())) {
                        searchedRows.push(rows[idx]);
                        break;
                    }
                } else {

                    if (fuzzysearch(String(searchTerm).toLowerCase(), JSON.stringify(rows[idx][jdx].rawValue).toLowerCase())) {
                        searchedRows.push(rows[idx]);
                        break;
                    }
                }
            }
        }


        this.setState({
            rows:searchedRows,
            pageNumberTotal: Math.round(searchedRows.length/this.state.rowLimit),
            pageIndex : 0
        })
    }

    

    getCsv(){

    }

    render(){

        return (

            <div>
                <TableControlsComponent disableChangeCols={this.props.disableChangeCols} enableActions={this.state.enableActions} additionalButtons={this.state.additionalButtons} columns={ this.state.columns } onSearch={this.handelUserSearch.bind(this)}  onColumnsUpdate={this.updateDisplayableColumns.bind(this)} />
                <div className="table-responsive">
                    <table id="data-table-selection" className="table table-striped">
                        <TableHeader columns={ this.state.columns }/>
                        <TableBody rows={this.getRowSection()} deleteaction={this.state.deleteaction} editaction={this.state.editaction} editButtonText={this.state.editButtonText}/>
                    </table>
                </div>
                <TableFooter deleteaction={this.state.deleteaction} totalRows={this.state.totalRows} totalDisplayed={this.getRowSection().length} maxRowAmount={this.state.rowLimit} numberOfPages={this.state.pageNumberTotal} pageIndex={this.state.pageIndex} updateIndex={ this.updatePageIndex.bind(this) }/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/tables/table.component.js